import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import { useAuth } from "@/layouts/AuthContext";

export default function AuthGuard() {
    const { isAuthenticated, isLoggingOut, user } = useAuth();
    const location = useLocation();
    const { lang } = useParams();
    const baseRoute = `/${lang || "id"}`;

    if (!isAuthenticated) {
        return (
            <Navigate
                to={`${baseRoute}/login`}
                state={{ from: location, requireLogin: !isLoggingOut }}
                replace
            />
        );
    }

    if (!user?.emailVerifiedAt) {
        // Pengecualian khusus, jika route saat ini adalah /verify-email, jangan redirect lagi!
        if (location.pathname === `${baseRoute}/verify-email`) {
            return <Outlet />;
        }
        return (
            <Navigate
                to={`${baseRoute}/verify-email`}
                state={{
                    fromPath: `${location.pathname}${location.search}`,
                    fromState: location.state,
                }}
                replace
            />
        );
    }

    return <Outlet />;
}
